export default __webpack_public_path__ + "static/texture-yellow-dots-05-a5eecec72b2a39d4e91aa295254467db.png";